import { ApiProperty } from "@nestjs/swagger";

export class BiMessageIdRequest {
    @ApiProperty()
    biMessageId: number;
    @ApiProperty()
    username: string;

    /**
     * 
     * @param biMessageId 
     * @param username 
     */
    constructor(biMessageId: number, username: string) {
        this.biMessageId = biMessageId;
        this.username = username;
    }
}
